import { Component, Input } from '@angular/core';

@Component({
  selector: 'dashboard-order-status',
  templateUrl: './order-status.component.html',
  styleUrls: ['./order-status.component.scss']
})
export class DashboardOrderStatusComponent {
  @Input() orderStatus: any = {};
}
